<template>
  <v-container fluid>
    <v-row wrap>
      <v-col cols="3">
        <shop-select
          v-model="model.shopId"
          v-bind:disabled="this.prescriptionId ? true : false"
          :rules="[rules.notHeadOnlyRequired]"
        ></shop-select>
      </v-col>
      <v-col cols="3" d-flex>
        <location-autocomplete
          v-model="model.locationId"
          :disabled="!model.isModifiable"
          :rules="[rules.notHeadOnlyRequired]"
        ></location-autocomplete>
      </v-col>
      <v-col cols="2">
        <shipping-select
          :locationId="model.locationId"
          :disabled="!model.isModifiable"
          v-model="model.shipping_id"
          :rules="[rules.notHeadOnlyRequired]"
        ></shipping-select>
      </v-col>
      <v-col cols="2">
        <currency-select
          :locationId="model.locationId"
          :disabled="!model.isModifiable"
          v-model="model.currencyId"
          :rules="[rules.notHeadOnlyRequired]"
        ></currency-select>
      </v-col>
      <v-col cols="2">
        <tax-rate-autocomplete
            v-model="model.taxRateId"
            label="Tax Rate"
            :disabled="!model.isModifiable"
            :rules="[rules.notHeadOnlyRequired]"
        ></tax-rate-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <customer-autocomplete
          v-model="model.clientId"
          v-bind:disabled="this.prescriptionId ? true : false"
          :rules="[rules.notHeadOnlyRequired]"
        ></customer-autocomplete>
      </v-col>
      <v-col cols="3">
        <fitter-select v-model="model.clubFitterId" :disabled="!model.isModifiable"></fitter-select>
      </v-col>
      <v-col cols="2">
        <fitting-type-select
          v-model="model.fittingTypeId"
          :disabled="!model.isModifiable"
          :rules="[rules.notHeadOnlyRequired]"
        ></fitting-type-select>
      </v-col>
      <v-col cols="2">
        <v-menu
          v-model="datePicker"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="model.fittingDate"
              label="Fitting Date"
              readonly
              v-on="on"
              :disabled="!model.isModifiable"
            ></v-text-field>
          </template>
          <v-date-picker v-model="model.fittingDate" @input="datePicker = false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="model.clientPo"
          label="Client's PO"
          hint="To filled only if client have a PO number"
          @change="update"
          clearable
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CustomerAutocomplete from "@components/forms/autocomplete/Customer.vue";
import LocationAutocomplete from "@components/forms/autocomplete/Location.vue";
import FittingTypeSelect from "@components/forms/select/FittingType.vue";
import ShippingSelect from "@components/forms/select/Shipping.vue";
import CurrencySelect from "@components/forms/select/Currency.vue";
import FitterSelect from "@components/forms/select/Fitter.vue";
import ShopSelect from "@components/forms/select/Shop.vue";
import TaxRateAutocomplete from "../../components/forms/autocomplete/TaxRate.vue"

function getDefaultData() {
  return {
    model: this.prescription,
    items: [],
    mandatoryRules: [v => !!v || "This fiels is mandatory"],
    message: null,
    valid: null,
    datePicker: false,
    loading: false,
    prescriptionId: this.prescription ? this.prescription.id : null
  };
}
export default {
  components: {
    CustomerAutocomplete,
    LocationAutocomplete,
    FittingTypeSelect,
    ShippingSelect,
    CurrencySelect,
    TaxRateAutocomplete,
    FitterSelect,
    ShopSelect
  },
  props: ["prescription"],
  data: getDefaultData,
  methods: {
    update() {
      if (this.prescriptionId) {
        this.loading = true;
        this.$store
          .dispatch("prescriptions/update", {
            prescriptionId: this.prescriptionId,
            model: this.model
          })
          .finally(() => {
            this.loading = false;
            this.$emit("update");
          });
      }
      this.$emit("input", this.model);
    }
  },
  computed: {
    rules: function() {
      return {
        required: value => !!value || "This field is mandatory.",
        notHeadOnlyRequired: value => {
          if (this.model.headOnly) return true;
          return !!value || "This field is mandatory.";
        }
      };
    }
  },
  watch: {
    "model.locationId": function() {
      this.update();
    },
    "model.clubFitterId": function() {
      this.update();
    },
    "model.fittingTypeId": function() {
      this.update();
    },
    "model.shipping_id": function() {
      this.update();
    },
    "model.shopZoneId": function() {
      this.update();
    },
    "model.fittingDate": function() {
      this.update();
    },
    "model.currencyId": function() {
      this.update();
    },
    "model.taxRateId": function() {
      this.update();
    },
    "model.shopId": function() {
      this.update();
    }
  }
};
</script>

<style></style>
